"use client";

import { useRef, useState } from "react";
import type { WorkbenchIdentity } from "./identity";

type RoleChoice = "creator" | "brand" | "director" | "agent-mcn";

export function WorkbenchRoleSwitcher({ identity, agentType }: { identity: WorkbenchIdentity; agentType?: "mcn" | "store" | null }) {
  const current: RoleChoice = identity === "agent" ? "agent-mcn" : identity === "partner" ? "brand" : identity === "signed" ? "creator" : identity;
  const [target, setTarget] = useState(current);
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);
  const [error, setError] = useState("");

  async function switchRole(next: typeof current) {
    if (pending.current) return;
    pending.current = true;
    setTarget(next);
    setBusy(true);
    setError("");
    try {
      const response = await fetch("/api/account/workbench-role", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ identity: next.startsWith("agent-") ? "agent" : next, ...(next.startsWith("agent-") ? { agentType: "mcn" } : {}), currentIdentity: identity === "signed" ? "creator" : identity, currentAgentType: agentType ?? null }) });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || "切换未完成，请刷新重试");
      }
      window.location.assign(result.next === "/creator" ? "/creator" : "/partner");
    } catch (reason) {
      setTarget(current);
      setError(reason instanceof Error ? reason.message : "切换未完成，请刷新核对当前身份");
      setBusy(false);
      pending.current = false;
    }
  }

  return <div className="wb-role-switcher">
    <select className="wb-role-select" aria-label="切换身份" aria-busy={busy} value={target} disabled={busy}
      onChange={event => { void switchRole(event.target.value as typeof current); }}>
      <option value="creator">个体授权方</option><option value="brand">电商厂商</option><option value="director">影视厂商</option><option value="agent-mcn">代理商</option>
    </select>
    {error && <div className="wb-role-panel">
      <p role="alert" className="text-red-600">{error}</p>

    </div>}
  </div>;
}
